import React from "react";
import DropDown from '../dropdown';
import { GetHotelAddons } from '../../../api/services/pms';
import { Currencies } from "../currencies";

export const HotelAddonDropDown = ({ ...rest }) => {
    const currencyFormat = (item) => {
        return item?.CurrencyID && Currencies[item?.CurrencyID]?.symbol || ''
    }
    return <DropDown api={GetHotelAddons} textField="Name" valueField="Id" descriptionField={currencyFormat} {...rest} />
}